import type { ConfigurationActions } from "../coachingGeneratorStore";

export const createConfigurationActions = (set: any): ConfigurationActions => ({
  setCustomPrompt: (prompt: string) => set({ customPrompt: prompt }),

  setSystemPrompt: (prompt: string) => set({ systemPrompt: prompt }),

  setTemperature: (temperature: number) => set({ temperature }),

  setIncludeAttributeStats: (include: boolean) =>
    set({ includeAttributeStats: include }),

  setIncludeLensDefinition: (include: boolean) =>
    set({ includeLensDefinition: include }),

  setIncludeTeamBestPractices: (include: boolean) =>
    set({ includeTeamBestPractices: include })
});
